import styled from 'styled-components';

export const PopOverOptionsStyled = styled.div`
  display: inline-flex;
  flex-direction: column;

  .venuesPopOverOptions {
    &__option {
      min-width: 155px;
      width: auto;
      white-space: nowrap;
    }
  }
`;
